import {TOracleBoolType} from 'shared/types';

/**
 * Проверяет, является ли значение валидным Oracle-булевым типом ('Y' или 'N')
 * 
 * @param value - Проверяемое значение
 * @returns true если значение 'Y' или 'N', иначе false
 */
export const isOracleBoolType = (value: unknown): value is TOracleBoolType => value === 'Y' || value === 'N';
